export const appConstants = {
    LIMIT: 10,
    SELECT_ASSESSMENT_LIMIT: 6,
    VIDEO_ID: '7AWsQ1mVYZg'
}